<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openAcceptanceReceiptDialog(formModel)"
        >
          Receipt of Delivery
        </v-btn>
        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openTechnicalHandoverProtocolDialog(formModel)"
        >
          Technical Handover Protocol
        </v-btn>
        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openCommissioningProtocolDialog(formModel)"
        >
          Commissioning Report
        </v-btn>

        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openWarrantyCertificateDialog()"
        >
          Warranty Certificate
        </v-btn>

        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openDeclarationOfConformityDialog()"
        >
          Declaration of Conformity
        </v-btn>

        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openQualityCertificateDialog()"
        >
          Certificate of Quality
        </v-btn>

        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openSalesContractDialog()"
        >
          Sales Contract
        </v-btn>
        <v-btn
          color="primary"
          class="mr-2 mb-2"
          elevation="2"
          :disabled="!formModel.id"
          @click="openFinancialCompletionCertificateDialog()"
        >
          Certificate of Financial Compliance
        </v-btn>

        <v-btn
          color="primary"
          @click="openDeliveryNotePlanner"
        >
        <!--:disabled="Number(formModel.status) < 5"-->
          Delivery Note
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="formModel.id" class="mb-1">
      <v-col cols="12" sm="6" lg="3">
        <v-card outlined class="summary-card fill-height">
          <v-card-text>
            <div class="subtitle-1 text--secondary mb-1">Total documents</div>
            <div class="text-h5 font-weight-bold">{{ summaryDocuments.length }}</div>
            <div class="body-2 mt-2">Generated / Planned: {{ generatedDocumentsCount }} · Signed / Issued: {{ signedDocumentsCount }}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card outlined class="summary-card summary-card--success fill-height">
          <v-card-text>
            <div class="subtitle-1 text--secondary mb-1">Latest issue date</div>
            <div class="text-h5 font-weight-bold">{{ latestIssuedAtLabel }}</div>
            <div class="body-2 mt-2">Based on issued_at, document_date or created_at</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card outlined class="summary-card fill-height">
          <v-card-text>
            <div class="subtitle-1 text--secondary mb-1">Active documents</div>
            <div class="text-h5 font-weight-bold">{{ activeDocumentsCount }}</div>
            <div class="body-2 mt-2">Generated, signed or issued documents</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card
          outlined
          class="summary-card fill-height"
          :class="cancelledDocumentsCount > 0 ? 'summary-card--warning' : 'summary-card--neutral'"
        >
          <v-card-text>
            <div class="subtitle-1 text--secondary mb-1">Cancelled documents</div>
            <div
              class="text-h6 font-weight-bold"
              :class="cancelledDocumentsCount > 0 ? 'warning--text text--darken-2' : 'success--text'"
            >
              {{ cancelledDocumentsCount }}
            </div>
            <div class="body-2 mt-2">
              <span v-if="cancelledDocumentsCount > 0">Review cancelled records</span>
              <span v-else>No cancelled generated document</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="so-view-switcher">
          <v-btn
            small
            :color="documentTypeFilter === 'all' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'all'"
            @click="documentTypeFilter = 'all'"
          >
            All
          </v-btn>
          <v-btn
            small
            :color="documentTypeFilter === 'delivery_acceptance_receipt' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'delivery_acceptance_receipt'"
            @click="documentTypeFilter = 'delivery_acceptance_receipt'"
          >
            Receipt of Delivery
          </v-btn>
          <v-btn
            small
            :color="documentTypeFilter === 'technical_handover_protocol' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'technical_handover_protocol'"
            @click="documentTypeFilter = 'technical_handover_protocol'"
          >
            Technical Handover Protocol
          </v-btn>
          <v-btn
            small
            :color="documentTypeFilter === 'commissioning_protocol' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'commissioning_protocol'"
            @click="documentTypeFilter = 'commissioning_protocol'"
          >
            Commissioning Report
          </v-btn>
          <v-btn
            small
            :color="documentTypeFilter === 'warranty_certificate' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'warranty_certificate'"
            @click="documentTypeFilter = 'warranty_certificate'"
          >
            Warranty Certificate
          </v-btn>
          <v-btn
            small
            :color="documentTypeFilter === 'declaration_of_conformity' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'declaration_of_conformity'"
            @click="documentTypeFilter = 'declaration_of_conformity'"
          >
            Declaration of Conformity
          </v-btn>
          <v-btn
            small
            :color="documentTypeFilter === 'quality_certificate_batch' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'quality_certificate_batch'"
            @click="documentTypeFilter = 'quality_certificate_batch'"
          >
            Certificate of Quality
          </v-btn>                  
          <v-btn
            small
            :color="documentTypeFilter === 'sales_contract' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'sales_contract'"
            @click="documentTypeFilter = 'sales_contract'"
          >
            Sales Contract
          </v-btn>
          <v-btn
            small
            :color="documentTypeFilter === 'financial_completion_certificate' ? 'primary' : undefined"
            :outlined="documentTypeFilter !== 'financial_completion_certificate'"
            @click="documentTypeFilter = 'financial_completion_certificate'"
          >
            Certificate of Financial Compliance
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="!formModel.id">
      <v-col cols="12">
        <v-alert outlined dense type="info">
          Save the sales order first, then you can create and review the related generated documents here.
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12">
        <v-simple-table class="document-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th>Type</th>
                <th>Title</th>
                <th>Status</th>
                <th>Issued</th>
                <th>Created by</th>
                <th>Comment</th>
                <th class="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="displayGeneratedDocuments.length === 0">
                <td colspan="7" class="text-center py-4">
                  No generated documents found for the selected filter.
                </td>
              </tr>

              <tr
                v-for="document in displayGeneratedDocuments"
                :key="`generated-document-${document.id}`"
              >
                <td>
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2">
                      mdi-file-document-outline
                    </v-icon>
                    <div>
                      <div class="font-weight-medium">
                        {{ generatedDocumentTypeLabel(document) }}
                      </div>
                      <div v-if="document.template_key" class="body-2 text--secondary">
                        {{ document.template_key }}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{ document.title || '-' }}</td>
                <td>
                  <v-chip
                    x-small
                    label
                    :color="documentStatusColor(document.status)"
                    dark
                  >
                    {{ documentStatusLabel(document.status) }}
                  </v-chip>
                </td>
                <td>{{ formatDocumentDate(document.issued_at || document.created_at) }}</td>
                <td>{{ resolveGeneratedDocumentCreator(document) }}</td>
                <td>{{ document.comment || '-' }}</td>
                <td class="text-right">
                  <v-btn
                    small
                    text
                    color="red"
                    @click="deleteGeneratedDocument(document)"
                  >
                    DELETE
                  </v-btn>
                  <v-btn
                    small
                    text
                    color="primary"
                    :disabled="!getGeneratedDocumentPdfUrl(document)"
                    @click="openGeneratedDocumentPdf(document)"
                    class="pdf-btn"
                  >
                    PDF
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row v-if="formModel.id" class="mt-4">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="text-h6 font-weight-bold d-flex align-center">
            <span>Delivery notes</span>
            <v-spacer />
            <v-progress-circular
              v-if="loadingDeliveryNotes"
              indeterminate
              size="20"
              width="2"
              color="primary"
            />
          </v-card-title>
        
          <v-divider />
        
          <v-card-text class="pa-0">
            <v-simple-table class="document-table delivery-notes-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Status</th>
                    <th>Exhibition Date</th>
                    <th>Delivery Date</th>
                    <th>Total weight</th>
                    <th>Comment</th>
                    <th class="text-right">Action(s)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="sortedDeliveryNotes.length === 0">
                    <td colspan="7" class="text-center py-4">
                      There is no delivery note(s) for this order.
                    </td>
                  </tr>
                
                  <tr
                    v-for="note in sortedDeliveryNotes"
                    :key="`delivery-note-${note.id}`"
                  >
                    <td>{{ note.number || "#" + note.id }}</td>
                
                    <td>
                      <v-chip
                        small
                        label
                        :color="deliveryNoteStatusColor(note.status)"
                        dark
                      >
                        {{ deliveryNoteStatusLabel(note.status) }}
                      </v-chip>
                    </td>
                  
                    <td>{{ formatDocumentDate(note.document_date) }}</td>
                    <td>{{ formatDocumentDate(note.delivery_date) }}</td>
                    <td>{{ Number(note.total_weight || 0).toFixed(2) }} kg</td>
                    <td>{{ note.comment || "-" }}</td>
                  
                    <td class="text-right">
                      <v-btn
                        small
                        text
                        color="red"
                        :loading="deletingDeliveryNoteId === note.id"
                        :disabled="deletingDeliveryNoteId === note.id"
                        @click="deleteDeliveryNote(note)"
                      >
                        DELETE
                      </v-btn>

                      <v-btn
                        small
                        text
                        color="primary"
                        @click="$refs.deliveryNotePlanner.openExisting(note.id)"
                      >
                        OPEN
                      </v-btn>
                    
                      <v-btn
                        small
                        text
                        color="primary"
                        :disabled="note.status !== 'issued' || deletingDeliveryNoteId === note.id"
                        @click="openDeliveryNotePdf(note)"
                        class="pdf-btn"
                      >
                        PDF
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <BaseSnackbar
      v-model="uSnackbar.show"
      :text="uSnackbar.text"
      :color="uSnackbar.color"
      :timeout="uSnackbar.timeout"
      :bottom="false"
      :top="true"
      :right="false"
    />

    <AcceptanceReceiptDialog
      v-model="acceptanceReceiptDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <TechnicalHandoverProtocolDialog
      v-model="technicalHandoverProtocolDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <CommissioningProtocolDialog
      v-model="commissioningProtocolDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <WarrantyCertificateDialog
      v-model="warrantyCertificateDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <DeclarationOfConformityDialog
      v-model="declarationOfConformityDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <QualityCertificateDialog
      v-model="qualityCertificateDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <SalesContractDialog
      v-model="salesContractDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <FinancialCompletionCertificateDialog
      v-model="financialCompletionCertificateDialog"
      :sales-order-id="formModel.id"
      @generated="handleGeneratedDocument"
    />

    <delivery-note-planner-dialog
      ref="deliveryNotePlanner"
      v-model="plannerDialog"
      @saved="handleDeliveryNoteSaved"
      @issued="handleDeliveryNoteSaved"
    />
  </div>
</template>

<script>
import BaseSnackbar from "./BaseSnackbar.vue";
import AcceptanceReceiptDialog from "./AcceptanceReceiptDialog.vue";
import { ENDPOINT } from "../SalesOrders";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import TechnicalHandoverProtocolDialog from "./TechnicalHandoverProtocolDialog.vue";
import CommissioningProtocolDialog from "./CommissioningProtocolDialog.vue";
import WarrantyCertificateDialog from "./WarrantyCertificateDialog.vue";
import DeclarationOfConformityDialog from "./DeclarationOfConformityDialog.vue";
import QualityCertificateDialog from "./QualityCertificateDialog.vue";
import SalesContractDialog from "./SalesContractDialog.vue";
import FinancialCompletionCertificateDialog from "./FinancialCompletionCertificateDialog.vue";

import DeliveryNotePlannerDialog from "../../../transport/transportOrders/DeliveryNotePlannerDialog.vue";

export default {
  name: "SalesOrderDocumentsPanel",
  components: {
    BaseSnackbar,
    AcceptanceReceiptDialog,
    TechnicalHandoverProtocolDialog,
    CommissioningProtocolDialog,
    WarrantyCertificateDialog,
    DeclarationOfConformityDialog,
    QualityCertificateDialog,
    SalesContractDialog,
    FinancialCompletionCertificateDialog,
    DeliveryNotePlannerDialog,
  },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      documentTypeFilter: "all",
      acceptanceReceiptDialog: false,
      selectedSalesOrderId: null,
      uSnackbar: {
        show: false,
        text: "",
        color: "success",
        timeout: 3000,
      },
      technicalHandoverProtocolDialog: false,
      commissioningProtocolDialog: false,
      warrantyCertificateDialog: false,
      declarationOfConformityDialog: false,
      qualityCertificateDialog: false,
      salesContractDialog: false,
      financialCompletionCertificateDialog: false,
      plannerDialog: false,

      deliveryNotes: [],
      loadingDeliveryNotes: false,
      deletingDeliveryNoteId: null,
    };
  },
  computed: {
    normalizedGeneratedDocuments() {
      if (!Array.isArray(this.formModel.generatedDocuments)) {
        return [];
      }

      return this.formModel.generatedDocuments.map((document) => ({
        ...document,
        type: this.normalizeDocumentType(document.type),
      }));
    },

    sortedGeneratedDocuments() {
      return [...this.normalizedGeneratedDocuments].sort((a, b) => {
        return this.getDocumentTimestamp(b) - this.getDocumentTimestamp(a);
      });
    },

    sortedDeliveryNotes() {
      return [...this.deliveryNotes].sort((a, b) => {
        return new Date(b.issued_at || b.created_at || 0).getTime()
          - new Date(a.issued_at || a.created_at || 0).getTime();
      });
    },

    summaryDocuments() {
      const generatedDocuments = this.sortedGeneratedDocuments.map((document) => ({
        source_type: "generated_document",
        original_status: String(document.status || "").toLowerCase(),
        summary_status: String(document.status || "").toLowerCase(),
        issued_at: document.issued_at || document.created_at || null,
        ...document,
      }));

      const deliveryNotes = this.sortedDeliveryNotes.map((note) => {
        const normalizedStatus = String(note.status || "").toLowerCase();

        return {
          ...note,
          source_type: "delivery_note",
          original_status: normalizedStatus,
          summary_status: normalizedStatus === "cancelled"
            ? "cancelled"
            : normalizedStatus === "issued"
              ? "signed"
              : "generated",
          issued_at: note.document_date || note.issued_at || note.created_at || null,
        };
      });

      return [...generatedDocuments, ...deliveryNotes].sort((a, b) => {
        return this.getDocumentTimestamp(b) - this.getDocumentTimestamp(a);
      });
    },

    displayGeneratedDocuments() {
      if (this.documentTypeFilter === "all") {
        return this.sortedGeneratedDocuments;
      }

      return this.sortedGeneratedDocuments.filter(
        (document) => document.type === this.documentTypeFilter
      );
    },

    generatedDocumentsCount() {
      return this.summaryDocuments.filter((document) => {
        return document.summary_status === "generated";
      }).length;
    },

    signedDocumentsCount() {
      return this.summaryDocuments.filter((document) => {
        return document.summary_status === "signed" || document.summary_status === "issued";
      }).length;
    },

    cancelledDocumentsCount() {
      return this.summaryDocuments.filter((document) => {
        return document.summary_status === "cancelled";
      }).length;
    },

    activeDocumentsCount() {
      return this.summaryDocuments.filter((document) => {
        return document.summary_status !== "cancelled";
      }).length;
    },

    latestIssuedAtLabel() {
      const latestDocument = this.summaryDocuments[0];

      if (!latestDocument) {
        return "-";
      }

      return this.formatDocumentDate(latestDocument.issued_at);
    },
  },
  methods: {
    ensureGeneratedDocumentsArray() {
      if (!Array.isArray(this.formModel.generatedDocuments)) {
        this.$set(this.formModel, "generatedDocuments", []);
      }
    },

    normalizeDocumentType(type) {
      if (!type) return "";

      const normalized = String(type).toLowerCase().replace(/-/g, "_");

      if (normalized === "deliveryacceptancereceipt") {
        return "delivery_acceptance_receipt";
      }

      return normalized;
    },

    getDocumentTimestamp(document) {
      return new Date(document.issued_at || document.created_at || 0).getTime();
    },

    generatedDocumentTypeLabel(document) {
      const type = this.normalizeDocumentType(document.type);
      console.log(type);

      if (type === "delivery_acceptance_receipt") return "Átvételi elismervény";
      if (type === "technical_handover_protocol") return "Műszaki Átadás-átvételi jegyzőkönyv";
      if (type === "commissioning_protocol") return "Üzembe helyezési jegyzőkönyv";
      if (type === "warranty_certificate") return "Garancialevél";
      if (type === "declaration_of_conformity") return "Megfelelőségi nyilatkozat";
      if (type === "quality_certificate_batch") return "Minőségi bizonyítvány";
      if (type === "sales_contract") return "Adásvételi szerződés";
      if (type === "financial_completion_certificate") return "Pénzügyi teljesítésigazolás";

      return document.type || "-";
    },

    documentStatusLabel(status) {
      if (!status) return "-";

      const normalized = String(status).toLowerCase();

      if (normalized === "generated") return "Generated";
      if (normalized === "signed") return "Signed";
      if (normalized === "cancelled") return "Cancelled";
      if (normalized === "archived") return "Archived";

      return normalized.replace(/_/g, " ");
    },

    documentStatusColor(status) {
      const normalized = String(status || "").toLowerCase();

      if (normalized === "signed") return "success";
      if (normalized === "cancelled") return "error";
      if (normalized === "archived") return "grey";

      return "primary";
    },

    formatDocumentDate(value) {
      if (!value) return "-";

      const normalized = String(value).replace(" ", "T");
      const date = new Date(normalized);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return date.toLocaleDateString("hu-HU");
    },

    resolveGeneratedDocumentCreator(document) {
      if (document.creator && document.creator.name) {
        return document.creator.name;
      }

      if (document.created_by) {
        return `#${document.created_by}`;
      }

      return "-";
    },

    getGeneratedDocumentPdfUrl(document) {
      if (!document) return null;

      if (document.file_url) return document.file_url;

      const path = document.file_path || document.pdf_path;
      if (!path) return null;

      if (/^https?:\/\//i.test(path)) return path;

      const baseUrl = (
        process.env.VUE_APP_BACKEND_URL ||
        process.env.VUE_APP_PORTAL_URL ||
        process.env.VUE_APP_PORTAL ||
        window.location.origin ||
        ""
      ).replace(/\/$/, "");

      return `${baseUrl}/public/${String(path).replace(/^\/+/, "")}`;
    },

    openGeneratedDocumentPdf(document) {
      const pdfUrl = this.getGeneratedDocumentPdfUrl(document);

      if (!pdfUrl) return;

      window.open(pdfUrl, "_blank");
    },

    appendGeneratedDocument(document) {
      if (!document) return;

      this.ensureGeneratedDocumentsArray();

      const normalizedDocument = {
        ...document,
        type: this.normalizeDocumentType(document.type),
      };

      const existingIndex = this.formModel.generatedDocuments.findIndex(
        (item) => String(item.id) === String(normalizedDocument.id)
      );

      if (existingIndex === -1) {
        this.formModel.generatedDocuments.unshift(normalizedDocument);
      } else {
        this.$set(this.formModel.generatedDocuments, existingIndex, normalizedDocument);
      }
    },

    handleGeneratedDocument(responseData) {
      const document =
        responseData && responseData.document ? responseData.document : responseData;

      if (!document || !document.id) {
        this.showSnackbar("Generated document created successfully", "success", 5000);
        return;
      }

      this.appendGeneratedDocument(document);
      this.showSnackbar("Generated document created successfully", "success", 5000);
    },

    showSnackbar(text, color = "success", timeout = 3000) {
      this.uSnackbar.text = text;
      this.uSnackbar.color = color;
      this.uSnackbar.timeout = timeout;
      this.uSnackbar.show = true;
    },

    openAcceptanceReceiptDialog(order) {
      this.selectedSalesOrderId = order.id;
      this.acceptanceReceiptDialog = true;
    },

    async deleteGeneratedDocument(document) {
      if (!document || !document.id) return;

      const result = await Swal.fire({
        title: "<strong>ALERT</strong>",
        icon: "warning",
        width: "600px",
        text: "Are you sure you want to delete this document? This action cannot be undone.",
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: "Yes, delete it",
        confirmButtonColor: "#d33",
        showCancelButton: true,
        cancelButtonText: "Cancel",
      });
    
      if (!result.isConfirmed) return;
    
      try {
        await ApiService.delete(
          `${ENDPOINT}${this.formModel.id}/generated-documents/${document.id}`
        );
      
        this.removeGeneratedDocument(document.id);
        this.showSnackbar("Generated document deleted successfully", "success", 5000);
      } catch (error) {
        console.error(error);
        this.showSnackbar("Failed to delete generated document", "error", 5000);
      }
    },

    removeGeneratedDocument(documentId) {
      if (!Array.isArray(this.formModel.generatedDocuments)) {
        return;
      }
    
      const index = this.formModel.generatedDocuments.findIndex(
        (item) => String(item.id) === String(documentId)
      );
    
      if (index !== -1) {
        this.formModel.generatedDocuments.splice(index, 1);
      }
    },

    openTechnicalHandoverProtocolDialog() {
      this.technicalHandoverProtocolDialog = true;
    },

    openCommissioningProtocolDialog() {
      this.commissioningProtocolDialog = true;
    },

    openWarrantyCertificateDialog() {
      this.warrantyCertificateDialog = true;
    },

    openDeclarationOfConformityDialog() {
      this.declarationOfConformityDialog = true;
    },

    openQualityCertificateDialog() {
      this.qualityCertificateDialog = true;
    },

    openSalesContractDialog() {
      this.salesContractDialog = true;
    },

    openFinancialCompletionCertificateDialog() {
      this.financialCompletionCertificateDialog = true;
    },

    openDeliveryNotePlanner() {
      this.plannerDialog = true;

      this.$nextTick(() => {
        console.log("REF:", this.$refs.deliveryNotePlanner);

        if (
          this.$refs.deliveryNotePlanner &&
          typeof this.$refs.deliveryNotePlanner.openForSalesOrder === "function"
        ) {
          this.$refs.deliveryNotePlanner.openForSalesOrder(this.formModel.id);
        } else {
          console.error("A deliveryNotePlanner ref nem Vue komponens vagy nincs openForSalesOrder metódus.");
        }
      });
    },
    async loadDeliveryNotes() {
      if (!this.formModel.id) {
        this.deliveryNotes = [];
        return;
      }
    
      this.loadingDeliveryNotes = true;
    
      try {
        const { data } = await ApiService.get(
          "sales/salesOrder/delivery-note/by-sales-order",
          this.formModel.id
        );
      
        this.deliveryNotes = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error("Delivery notes load error", error);
        this.deliveryNotes = [];
      } finally {
        this.loadingDeliveryNotes = false;
      }
    },

    deliveryNoteStatusLabel(status) {
      const normalized = String(status || "").toLowerCase();
    
      if (normalized === "draft") return "Draft";
      if (normalized === "planned") return "Planned";
      if (normalized === "issued") return "Issued";
      if (normalized === "cancelled") return "Cancelled";
    
      return status || "-";
    },

    deliveryNoteStatusColor(status) {
      const normalized = String(status || "").toLowerCase();
    
      if (normalized === "issued") return "success";
      if (normalized === "planned") return "warning";
      if (normalized === "cancelled") return "error";
    
      return "grey";
    },

    handleDeliveryNoteSaved(responseData) {
      if (responseData && responseData.delivery_note) {
        this.upsertDeliveryNote(responseData.delivery_note);
        return;
      }
    
      if (responseData && responseData.id) {
        this.upsertDeliveryNote(responseData);
        return;
      }
    
      this.loadDeliveryNotes();
    },

    upsertDeliveryNote(note) {
      if (!note || !note.id) return;
    
      const index = this.deliveryNotes.findIndex(
        (item) => String(item.id) === String(note.id)
      );
    
      if (index === -1) {
        this.deliveryNotes.unshift(note);
      } else {
        this.$set(this.deliveryNotes, index, note);
      }
    },

    async deleteDeliveryNote(note) {
      if (!note || !note.id) return;

      const result = await Swal.fire({
        title: "<strong>ALERT</strong>",
        icon: "warning",
        width: "600px",
        text: "Are you sure you want to delete this delivery note? This action cannot be undone.",
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: "Yes, delete it",
        confirmButtonColor: "#d33",
        showCancelButton: true,
        cancelButtonText: "Cancel",
      });

      if (!result.isConfirmed) return;

      this.deletingDeliveryNoteId = note.id;

      try {
        await ApiService.delete(`sales/salesOrder/delivery-note/${note.id}`);

        this.removeDeliveryNote(note.id);
        this.showSnackbar("Delivery note deleted successfully", "success", 5000);
      } catch (error) {
        console.error("Delivery note delete error", error);
        this.showSnackbar("Failed to delete delivery note", "error", 5000);
      } finally {
        this.deletingDeliveryNoteId = null;
      }
    },

    removeDeliveryNote(noteId) {
      const index = this.deliveryNotes.findIndex(
        (item) => String(item.id) === String(noteId)
      );

      if (index !== -1) {
        this.deliveryNotes.splice(index, 1);
      }
    },

    openDeliveryNotePdf(note) {
      if (!note || !note.id) return;


      const url =
        (process.env.VUE_APP_BACKEND_URL || "").replace(/\/$/, "") +
        "/public/" + note.pdf_path;
      
      window.open(url, "_blank");
    },
  },
  watch: {
    "formModel.id": {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadDeliveryNotes();
        } else {
          this.deliveryNotes = [];
        }
      },
    },
  },
};
</script>

<style scoped>
.so-view-switcher {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.summary-card {
  border-radius: 12px;
}

.summary-card--success {
  border-color: rgba(76, 175, 80, 0.35) !important;
  background: rgba(76, 175, 80, 0.04);
}

.summary-card--warning {
  border-color: rgba(255, 152, 0, 0.35) !important;
  background: rgba(255, 152, 0, 0.05);
}

.summary-card--neutral {
  border-color: rgba(76, 175, 80, 0.35) !important;
  background: rgba(76, 175, 80, 0.04);
}

.document-table th,
.document-table td {
  white-space: nowrap;
  font-size: 14px;
}

.document-table th {
  font-size: 15px;
  font-weight: 600;
}

.document-table td {
  vertical-align: middle;
}

.summary-card .subtitle-1,
.summary-card .body-2,
.summary-card .text-h5 {
  line-height: 1.35;
}

.so-view-switcher .v-btn,
.v-alert{
  font-size: 14px;
}

.pdf-btn {
  background: gray;
  color: white !important;
  font-size: 14px;
}

.delivery-notes-table th,
.delivery-notes-table td {
  font-size: 15px !important;
}

.delivery-notes-table th {
  font-size: 16px !important;
  font-weight: 600;
}
</style>